import { createSelector } from '@reduxjs/toolkit';
import { createMetaBindings } from '@ff-scene-plugins/gift-redux/slices/metaSlice';

const {
    createMetaUpdateAction,
    createMetaSelector,
    createPublicMetaSelector,
    createPublicMetaUpdateAction
} = createMetaBindings();

export const updateCommission = createPublicMetaUpdateAction('commission');
export const updatePrefabId = createPublicMetaUpdateAction('prefabId');

export const updateViewboxWidth = createMetaUpdateAction('viewboxWidth');
export const updateViewboxHeight = createMetaUpdateAction('viewboxHeight');

export const updateActiveVariantId = createMetaUpdateAction('activeVariantId');

export const selectActivePrefabId = createPublicMetaSelector(p => p.prefabId);
export const selectActiveCommission = createPublicMetaSelector(p => p.commission);

export const selectMetaViewboxWidth = createMetaSelector(m => m.viewboxWidth);
export const selectMetaViewboxHeight = createMetaSelector(m => m.viewboxHeight);

export const selectMetaViewbox = createSelector([
    selectMetaViewboxWidth,
    selectMetaViewboxHeight
], (width: number, height: number) => ({ width: width, height: height }));